import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import moment from "moment";
import Task, { TaskPriority, TaskStatus } from "@/models/Task";
import { useDataProvider } from "@/providers/DataProvider";
import { useNavigate } from "react-router-dom";
import { TaskForm } from "@/components/TaskForm";

export const TaskCreateDialog: React.FC = () => {
  const { categories, tags, addTask } = useDataProvider();

  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [categoryId, setCategoryId] = useState<string | null>(
    categories.length > 0 ? categories[0].id : null,
  );
  const [priority, setPriority] = useState<TaskPriority>(TaskPriority.LOW);
  const [dueDate, setDueDate] = useState<string>("");
  const [selectedTagIds, setSelectedTagIds] = useState<string[]>([]);

  const navigate = useNavigate();

  const resetForm = () => {
    setTitle("");
    setDescription("");
    setCategoryId(categories.length > 0 ? categories[0].id : null);
    setPriority(TaskPriority.LOW);
    setDueDate("");
    setSelectedTagIds([]);
  };

  const handleHide = () => {
    resetForm();
    navigate(-1);
  };

  const handleCreate = () => {
    if (title.trim() === "") return;
    const task = new Task({
      title,
      description,
      status: TaskStatus.TODO,
      dueDate: dueDate ? moment(dueDate) : null,
      priority,
      createdAt: moment(),
      updatedAt: moment(),
      deletedAt: null,
      tagsIds: selectedTagIds,
      categoryId,
    });
    addTask(task);
    handleHide();
  };

  return (
    <Modal show onHide={handleHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Create New Task</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <TaskForm
          title={title}
          setTitle={setTitle}
          description={description}
          setDescription={setDescription}
          categoryId={categoryId}
          setCategoryId={setCategoryId}
          priority={priority}
          setPriority={setPriority}
          dueDate={dueDate}
          setDueDate={setDueDate}
          selectedTagIds={selectedTagIds}
          setSelectedTagIds={setSelectedTagIds}
          categories={categories}
          tags={tags}
          onSubmit={handleCreate}
          onCancel={handleHide}
          submitLabel="Create Task"
        />
      </Modal.Body>
    </Modal>
  );
};

export default TaskCreateDialog;
